import { render, staticRenderFns } from "./CriteriaModal.vue?vue&type=template&id=035d4f9e&scoped=true&"
import script from "./CriteriaModal.vue?vue&type=script&lang=js&"
export * from "./CriteriaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d4f9e",
  null
  
)

export default component.exports